import { render, staticRenderFns } from "./oilList.vue?vue&type=template&id=ce7cbb9c&scoped=true"
import script from "./oilList.vue?vue&type=script&lang=js"
export * from "./oilList.vue?vue&type=script&lang=js"
import style0 from "./oilList.vue?vue&type=style&index=0&id=ce7cbb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7cbb9c",
  null
  
)

export default component.exports